import MapCreator from './map-creator';

export default MapCreator;
